import { addYears } from 'date-fns';

import { dateToISO } from './date-to-iso';

/**
 * Adds a specified number of years to a given date and returns it as an ISO string.
 *
 * @param  years - The number of years to add to the date.
 * @param date - The date to which years are added (default is the current date).
 * @returns A string representing the date with added years in ISO format (e.g., "YYYY-MM-DDTHH:mm:ss.sssZ").
 */
export function addYearsToString(years: number, date = new Date()): string {
  return dateToISO(addYears(date, years));
}
